import { Routes, Route } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { Context } from "./Context";
import {
  GET_ALL_COUNTRY,
  GET_ALL_STATE_BY_COUNTY_ID,
  GET_ALL_STATE_BY_NAME,
  USER_PROFILE,
  fetchData,
} from "./Service";
import Home from "../modules/home/Home";
import AboutUs from "../modules/about-us/AboutUs";
import Privacy from "../modules/privacy/Privacy";
import CountryLayout from "./layout/CountryLayout";
import Disclaimer from "../modules/disclaimer/Disclaimer";
import Autos from "../modules/autos/Autos";
import Carpool from "../modules/carpool/Carpool";
import Advertise from "../modules/advertise/Advertise";
import BusinessListing from "../modules/business-listing/BusinessListing";
import ContactUs from "../modules/contact-us/ContactUs";
import FreeAds from "../modules/free-ads/FreeAds";
import Movie from "../modules/movies/Movie";
import RealEstate from "../modules/real-estate/RealEstate";
import StudentTalk from "../modules/student-talks/StudentTalk";
import TermsCondition from "../modules/terms-condition/TermsCondition";
import Forum from "../modules/forum/Forum";
import ForumDetails from "../modules/forum/ForumDetails";
import NrisTalk from "../modules/nris-talk/NrisTalk";
import NrisTalkDetails from "../modules/nris-talk/NrisTalkDetails";
import StudentTalkDetails from "../modules/student-talks/StudentTalkDetails";
import MovieReviews from "../modules/movies/MovieReviews";
import MovieReviewsDetails from "../modules/movies/MovieReviewsDetails";
import Event from "../modules/event/Event";
import EventDetails from "../modules/event/EventDetails";
import Traning from "../modules/traning/Traning";
import TraningDetails from "../modules/traning/TraningDetails";
import Blog from "../modules/blog/Blog";
import BlogDetails from "../modules/blog/BlogDetails";
import AdsWrapper from "./layout/AdsWrapper";
import RealEstateDetails from "../modules/real-estate/RealEstateDetails";
import CarpoolDetails from "../modules/carpool/CarpoolDetails";
import AutosDetails from "../modules/autos/AutosDetails";
import FreeAdsDetails from "../modules/free-ads/FreeAdsDetails";
import News from "../modules/news/News";
import NewsDetails from "../modules/news/NewsDetails";
import BusinessDetails from "../modules/business-listing/BusinessDetails";
import SearchResults from "../modules/search-results/SearchResults";
import MovieAll from "../modules/movies/MovieAll";
import CreateCarpool from "../modules/carpool/CreateCarpool";
import Classified from "../modules/free-ads/Classified";
import DesiPage from "../modules/desi-page/DesiPage";
import DesiPageDetails from "../modules/desi-page/DesiPageDetails";
import MyProfile from "../modules/profile/MyProfile";
import NotFound from "./NotFound";
import ChangeForgotPassword from "../modules/change-forgot-password/ChangeForgotPassword";
import CreateAds from "../modules/create-ads/CreateAds";
import VerifyEmail from "../modules/verify-email/VerifyEmail";
import useRandomToasts from "./ToastNotification";
import { parseCookies } from "nookies";
import { destroyCookie,setCookie } from "nookies";

const Routing = () => {
  const [context, setContext] = useState({ listView: true });
  const nrisCookies = parseCookies();
  const SESSION_DURATION = 45 * 60 * 1000;

const checkSession = () => {
  const expiresAt = parseInt(nrisCookies.NrisSessionTime);
  if (isNaN(expiresAt)) return false;
  
  console.log("Now:",new Date(), "ExpiresAt:",new Date( expiresAt),Date.now() < expiresAt);
  return Date.now() < expiresAt;

};
const checkSessionLocalStorage = () => {
  const expiresAt = parseInt(localStorage.getItem("NrisSessionTime"));
  if (isNaN(expiresAt)) return false;
  
  console.log("Now:",new Date(), "ExpiresAt:",new Date( expiresAt),Date.now() < expiresAt);
  return Date.now() < expiresAt;

};

  if (
    !(process.env.REACT_APP_LOCAL && process.env.REACT_APP_LOCAL === "true")
  ) {
    if (nrisCookies && nrisCookies.NrisToken && checkSession()) {
     
      const expiresAt = new Date().getTime() + SESSION_DURATION;
      setCookie(null, "NrisSessionTime", expiresAt.toString(), {
        maxAge: 2 * 24 * 60 * 60,
        path: "/",
        domain: ".nris.com",
        secure: true,
        httpOnly: false,
        sameSite: "lax",
      });
      localStorage.setItem("NrisSessionTime", expiresAt.toString());
     
      localStorage.setItem("__nristoken", nrisCookies?.NrisToken);
      localStorage.setItem("__nrisuser", nrisCookies?.NrisUser);
    } else {
      destroyCookie(null, 'NrisSessionTime', {
        path: '/',
        domain: '.nris.com',
      });
     
      localStorage.removeItem("__nristoken");
      localStorage.removeItem("__nrisuser");
    }
  }

  const [token] = useState(localStorage.getItem("__nristoken"));
  const [countryId] = useState(
    nrisCookies && nrisCookies.CountryID ? nrisCookies.CountryID : 1
  );
  console.log(context);

  useRandomToasts();

  const host = window?.location?.hostname;

  const [subdomain] = useState(host && host.split("."));

  const getCountryState = () => {
    let country_id;

    if (host) {
      if (
        subdomain[0] !== "www" &&
        subdomain[0] !== "https://www" &&
        subdomain[0] !== "localhost" &&
        subdomain[0] !== "nris-stage" &&
        subdomain[0] !== "carboncompass"
      ) {
        const value = {
          states_name: [subdomain[0].replaceAll("-", " ").toLowerCase()],
        };

        if (
          value.states_name[0] !== "www" ||
          value.states_name[0] !== "localhost" ||
          value.states_name[0] !== ""
        ) {
          try {
            fetchData(
              GET_ALL_STATE_BY_NAME,
              "POST",
              value,
              false,
              false,
              (res) => {
                if (res.status) {
                  country_id = res?.data[0]?.country_id;
                  const state_name = res?.data[0]?.name;
                  const state_id = res?.data[0]?.id;

                  fetchData(GET_ALL_COUNTRY, "GET", "", false, false, (res) => {
                    if (res.status) {
                      setContext((prevValue) => ({
                        ...prevValue,
                        countryId: country_id,
                        countryList: res?.data,
                        stateView: true,
                        stateName: state_name,
                        stateId: state_id,
                      }));

                      fetchData(
                        GET_ALL_STATE_BY_COUNTY_ID,
                        "POST",
                        { country_id: country_id },
                        false,
                        false,
                        (res) => {
                          if (res.status) {
                            setContext((prevValue) => ({
                              ...prevValue,
                              stateList: res?.data,
                            }));
                          } else {
                            console.log(res);
                          }
                        }
                      );
                    } else {
                      console.log(res);
                    }
                  });
                } else {
                  console.log(res);
                }
              }
            );
          } catch (error) {
            console.log("error", error);
          }
        }
      } else {
        fetchData(GET_ALL_COUNTRY, "GET", "", false, false, (res) => {
          if (res.status) {
            setContext((prevValue) => ({
              ...prevValue,
              countryId: countryId ? countryId : res?.data[0]?.id,
              countryList: res?.data,
              stateView: false,
              stateName: "",
            }));

            let value = {
              country_id: countryId ? countryId : res?.data[0]?.id,
            };

            fetchData(
              GET_ALL_STATE_BY_COUNTY_ID,
              "POST",
              value,
              false,
              false,
              (res) => {
                if (res.status) {
                  setContext((prevValue) => ({
                    ...prevValue,
                    stateList: res?.data,
                    stateId: res?.data[0]?.id,
                  }));
                } else {
                  console.log(res);
                }
              }
            );
          } else {
            console.log(res);
          }
        });
      }
    }
  };

  useEffect(() => {
    if (token) {
      setContext((prevValue) => ({
        ...prevValue,
        user: JSON.parse(localStorage.getItem("__nrisuser")),
        userToken: token,
      }));
    }
    getCountryState();
  }, []);

  useEffect(() => {
    window.$(document).ready(function () {
      window.$(window).scroll(function () {
        if (window.$(this).scrollTop() > 50) {
          window.$(".header").addClass("bg-white");
        } else {
          window.$(".header").removeClass("bg-white");
        }
      });
    });
  }, []);

  const logout = () => {

    destroyCookie(null, 'NrisToken', {
      path: '/',
      domain: '.nris.com',
    });
    
    destroyCookie(null, 'NrisUser', {
      path: '/',
      domain: '.nris.com',
    });

    localStorage.removeItem("__nristoken");
    localStorage.removeItem("__nrisuser");

    destroyCookie(null, "NrisToken", { path: "/" });
    destroyCookie(null, "NrisUser", { path: "/" });
    setContext((prevValue) => ({
      ...prevValue,
      user: "",
      userToken: "",
    }));
    destroyCookie(null, 'NrisSessionTime', {
      path: '/',
      domain: '.nris.com',
    });
   
  };

// const resetTimer = useCallback(() => {
//   const SESSION_DURATION = 1 * 60 * 1000; // 1 minute

//   const expiresAt = Date.now() + SESSION_DURATION;
//   setCookie(null, "NrisSessionTime", expiresAt.toString(), {
//     maxAge: SESSION_DURATION / 1000,
//     path: "/",
//     secure: true,
//     sameSite: "lax",
//   });
// }, []);

//   useEffect(() => {
//     if (!localStorage.getItem("__nristoken")) return;

//     const checkInactivity = () => {
//       if (document?.hidden){
//         return
//       }
      
//       if (!checkSession() && nrisCookies.NrisToken) {

//         logout()
//         window.$("#inactiveSessionModal").modal("show");
//       }
//     };

//     resetTimer();

//     const interval = setInterval(checkInactivity, 60 * 1000);
//     const events = ["mousemove", "keydown", "click"];

//     events.forEach((event) => window.addEventListener(event, resetTimer));

//     return () => {
//       clearInterval(interval);
//       events.forEach((event) => window.removeEventListener(event, resetTimer));
//     };
//   }, [resetTimer]);

const resetTimer = () => {
 

  const expiresAt = Date.now() + SESSION_DURATION;
  console.log("Resetting session timer", new Date(expiresAt));
  setCookie(null, "NrisSessionTime", expiresAt.toString(), {
    maxAge: 2 * 24 * 60 * 60,
    path: "/",
    domain: ".nris.com",
    secure: true,
    httpOnly: false,
    sameSite: "lax",
  });
  localStorage.setItem("NrisSessionTime", expiresAt.toString());
};

  useEffect(() => {
    
    const interval = setInterval(() => {
      console.log("Checking session every 5 second", new Date().toISOString());
      if (document?.hidden){
        console.log("document?.hidden")
        return
      }
      if (!localStorage.getItem("__nristoken")) {
        console.log("nrisCookies.NrisToken")
        return
      }
      // Your logic here (e.g., checkSession)
      
      if (!checkSessionLocalStorage()) {
        logout();
        window.$("#inactiveSessionModal").modal("show");
      } else {
        resetTimer()
      }
  
    }, 5 * 1000); // 60,000 ms = 1 minute
  
    // Cleanup on unmount
    return () => clearInterval(interval);
  }, []);
  

  return (
    <>
      {context && context?.countryId && context?.stateId && (
        <Context.Provider value={[context, setContext]}>
          <Routes>
            <Route path="/" element={<CountryLayout />}>
              <Route index element={<Home />} />
              <Route path="login" element={<Home />} />
              <Route element={<AdsWrapper />}>
                <Route path="verify-email/:token" element={<VerifyEmail />} />
                <Route path="about-us" element={<AboutUs />} />
                <Route path="privacy" element={<Privacy />} />
                <Route path="disclaimer" element={<Disclaimer />} />
                <Route path="advertise-with-us" element={<Advertise />} />
                <Route
                  path="terms-and-conditions"
                  element={<TermsCondition />}
                />
                <Route path="contact-us" element={<ContactUs />} />
                <Route path="forums">
                  <Route path="" element={<Forum />} />
                  <Route path=":forum_id" element={<ForumDetails />} />
                </Route>
                <Route path="autos">
                  <Route path="" element={<Autos />} />
                  <Route path=":auto_id" element={<AutosDetails />} />
                  <Route
                    path="create-ads/:ads_id/:ads_type"
                    element={<CreateAds />}
                  />
                </Route>
                <Route path="business">
                  <Route path=":business_id" element={<BusinessListing />} />
                  <Route
                    path="details/:business_id"
                    element={<BusinessDetails />}
                  />
                </Route>
                <Route path="classifieds">
                  <Route path="" element={<Classified />} />
                  <Route path=":ads_id" element={<FreeAds />} />
                  <Route path="details/:ads_id" element={<FreeAdsDetails />} />
                  <Route
                    path="create-ads/:ads_id/:ads_type"
                    element={<CreateAds />}
                  />
                </Route>
                <Route path="carpool">
                  <Route path=":carpool_id" element={<Carpool />} />
                  <Route
                    path="details/:carpool_id"
                    element={<CarpoolDetails />}
                  />
                  <Route
                    path="create/:carpool_id"
                    element={<CreateCarpool />}
                  />
                </Route>
                <Route path="nri-talks">
                  <Route path="" element={<NrisTalk />} />
                  <Route path=":nris_talk_id" element={<NrisTalkDetails />} />
                </Route>
                <Route path="student-talks">
                  <Route path="" element={<StudentTalk />} />
                  <Route
                    path=":student_talk_id"
                    element={<StudentTalkDetails />}
                  />
                </Route>
                <Route path="movie-reviews">
                  <Route path="" element={<MovieReviews />} />
                  <Route
                    path=":movie_review_id"
                    element={<MovieReviewsDetails />}
                  />
                </Route>
                <Route path="events">
                  <Route path="" element={<Event />} />
                  <Route path=":event_id" element={<EventDetails />} />
                </Route>
                <Route path="traning-placemant">
                  <Route path="" element={<Traning />} />
                  <Route path=":traning_id" element={<TraningDetails />} />
                </Route>
                <Route path="news-articles">
                  <Route path="" element={<News />} />
                  <Route path=":news_id" element={<NewsDetails />} />
                </Route>
                <Route path="blogs">
                  <Route path="" element={<Blog />} />
                  <Route path=":blog_id" element={<BlogDetails />} />
                </Route>
                <Route path="movies">
                  <Route path="" element={<MovieAll />} />
                  <Route path=":lang_id" element={<Movie />} />
                </Route>
                <Route path="desi-page">
                  <Route path="" element={<DesiPage />} />
                  <Route path=":desi_page_id" element={<DesiPageDetails />} />
                </Route>
                <Route path="real-estate">
                  <Route path="" element={<RealEstate />} />
                  <Route
                    path=":real_estate_id"
                    element={<RealEstateDetails />}
                  />
                  <Route
                    path="create-ads/:ads_id/:ads_type"
                    element={<CreateAds />}
                  />
                </Route>
                <Route path="search-results">
                  <Route path="" element={<SearchResults />} />
                </Route>

                <Route
                  path="change-forgot-password/:cp_token"
                  element={<ChangeForgotPassword />}
                />
                {context?.userToken && (
                  <Route path="profile" element={<MyProfile />} />
                )}
                {context && context.id ? (
                  <></>
                ) : (
                  <Route path="/*" element={<NotFound />} />
                )}
              </Route>
            </Route>
          </Routes>
        </Context.Provider>
      )}
    </>
  );
};

export default Routing;
